export const APPLOG_ROOT_ENDPOINT = '/';
export const APPLOG_USER_LOG_GET = `/user-log`;
export const APPLOG_USER_LOG_GET_BUSINESS_ACTIONS = `/user-log/actions`;
